import {useState} from "react";
import {Button, Checkbox, Radio, Space} from "antd";
import {FilterOutlined} from "@ant-design/icons";

export interface FilterDropdownPropsType {
  ref:any
  defaultValue: any,
  type: string,
  typeAttrs: any,
  clearFilters: () => void,
  confirm: () => void,
  handleFilterReset: () => void,
  handleFilter: (filterValue:any) => void,
}

export default function FilterDropdown({ defaultValue, type, typeAttrs, clearFilters, confirm, handleFilterReset, handleFilter }:FilterDropdownPropsType) {
  const [filterValue, setFilterValue] = useState(defaultValue)
  
  console.log("Enum values", typeAttrs)

  return (
    <div style={{padding: 8}}>
        <Radio.Group value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}>
            <Space direction="vertical">
                { type === 'separatedList' && typeAttrs.items?.map((item:any) =>
                    <Checkbox key={item.value} value={item.value} onChange={evt => {
                      const oldElems = (filterValue || '').split('%').filter(e => e.length !== 0);
                      const newElems = [...oldElems.filter(k => k !== item.value), ...(evt.target.checked ? [item.value] : [])];
                      const newElemsSorted: string[] = [];
                      for(const item of typeAttrs.items.map(i => i.value)) {
                        if(newElems.includes(item)) {
                          newElemsSorted.push(item);
                        }
                      }
                      const newFilterValue = newElemsSorted.join("%")
                      console.log("New filter value", newFilterValue, newElems);
                      setFilterValue(newFilterValue)
                    }}>{item.label}</Checkbox>
                )}
                { type === 'enum' && typeAttrs.items?.map((item:any) =>
                    <Radio key={item.value} value={item.value}>{item.label}</Radio>
                )}
                {
                  type === 'boolean' && [true, false].map(item => 
                    <Radio key={`${item}`} value={`${item}`}>{ item ? 'Ja' : 'Nein' }</Radio>
                )}
                <Space>
                    <Button size="small"
                            style={{width: 90}}
                            onClick={() => {
                                clearFilters()
                                confirm()
                                handleFilterReset()
                            }}>Reset</Button>
                    <Button
                        type="primary"
                        icon={<FilterOutlined/>}
                        size="small"
                        style={{width: 90}}
                        onClick={() => {
                            confirm();
                            handleFilter(filterValue)
                        }}>Filter</Button>
                </Space>
            </Space>
        </Radio.Group>
    </div>
  )
}